module.exports = __webpack_public_path__ + "static/01-87c41d91dc33f9cf010aec54a5d7850d.png";